<wa-page>
  <div slot="header" class="header">
    <app-navbar style="width: 100%;"></app-navbar>
  </div>
  <main>
      <router-outlet></router-outlet>
      <wa-toast-container position="top-center"></wa-toast-container>
  </main>
</wa-page>

<!--div class="navbar-container">
    <app-navbar></app-navbar>
</div>
<div class="content-container">
    <div class="router-outlet">
        <router-outlet></router-outlet>
    </div>
</div-->
